import assetFields from "@wielink-application/shared/js/mixins/assetFields.js";
export default assetFields;
